import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { ListItemCellEditorComponent, ListItemCellEditorProps, IventisCellEditor } from "@iventis/data-table";
import { MapObjectRowNodeData } from "./sidebar-data-table.types";

export const PlansDataFieldListItemCellEditor = forwardRef<IventisCellEditor, ListItemCellEditorProps<MapObjectRowNodeData>>((props, ref) => {
    const { node } = props;

    const listItemCellEditorRef = useRef<IventisCellEditor>(null);

    useImperativeHandle(ref, () => ({
        getValue() {
            const value = listItemCellEditorRef.current?.getValue();
            // Update the property values that match the list item
            props.componentParams.onDone?.(value?.id, node);
            return value?.id;
        },
        isCancelBeforeStart() {
            return listItemCellEditorRef.current?.isCancelBeforeStart?.() ?? false;
        },
        isCancelAfterEnd() {
            return listItemCellEditorRef.current?.isCancelAfterEnd?.() ?? false;
        },
    }));

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <ListItemCellEditorComponent ref={listItemCellEditorRef} {...props} />;
});
